// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__6cRqt","container":"Videos_container__pQUCW","items":"Videos_items__zxgIZ"};